<template>
    <Tree :data="tree"
        ref="resTree"
        @on-select-change="onSelect"></Tree>
</template>
<script>
import { listToTree } from "_u/helper"
// 删除树节点（子级会一并删除）
function excludeNode(tree, map, id) {
    var node = map[id]
    if (node) {
        var parent = map[node.pid]
        var belongs = parent ? parent.children : tree
        belongs.splice(belongs.findIndex(v => v.id == id), 1)
    }
}

export default {
    name: "SelectDirectory",
    inject: {
        $modal: { default: null }
    },

    props: {
        list: {
            type: Array,
            default: () => []
        },
        exclude: {
            type: Array,
            default: () => []
        }
    },

    data() {
        return {
            tree: [],
            defaultIds: {}
        }
    },

    computed: {},

    mounted() {
        this.$modal.$on("lookup-open", data => {
            this.defaultIds = {}
            data.forEach(v => (this.defaultIds[v.value] = true))
            // 打开选择框
            this.$modal.beforeEnter(next => {
                var prods = {},
                    resList = []
                resList = this.list
                    .filter(v => v.type < 3)
                    .map(v => ({
                        id: v.id,
                        pid: v.pid,
                        title: v.title,
                        expand: true,
                        checked: this.defaultIds[v.id] == true
                    }))
                this.tree = listToTree(resList, {
                    id: "id",
                    pId: "pid",
                    done: (tree, map) => {
                        // 排除指定节点
                        this.exclude.forEach(id => excludeNode(tree, map, id))
                    }
                })
                next()
            })
        })
    },

    methods: {
        onSelect(nodes) {
            this.$modal.$emit("lookup-close", nodes)
        }
    }
}
</script>